import {gql} from "@apollo/client";

export const getUnits = gql`
  query getList {
    units {
      id
      name
    }
  }
`

export const getCategoryById = gql`
  query getItem($id: ID!) {
    category( id: $id) {
      id
      name
    }
  }
`

export const createCategoryMutation = gql`
  mutation createCategory($name: String!, $position: Int){
    createCategory(
      input: {
        name: $name,
        position: $position,
      }) {
      category {
        id
        name
        position
      }
    }
  }
`

export const updateCategoryMutation = gql`
  mutation updateCategory($id: ID!, $name: String!, $position: Int){
    updateCategory(
      input: {
        id: $id,
        name: $name,
        position: $position,
      }) {
      category {
        id
        name
        position
      }
    }
  }
`
